<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="company-settings-upload-history-claims-title">
                {{ $t('company.upload_history_claims.title') }}
            </div>
        </div>
        <upload-log-table :company_id="company_id" @onTableAction="onTableAction" ref="UploadLogTable" />
        <a-drawer
            data-cy="upload-drawer"
            :title="$t('company.upload_history.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <view-upload-log :upload_log="upload_log" @onDrawerClose="onClose" />
        </a-drawer>
    </div>
</template>

<script>
import UploadLogTable from '@/components/tables/UploadLogsClaims.vue';
import ViewUploadLog from '@/components/views/UploadLogClaim.vue';

export default {
    components: {
        UploadLogTable,
        ViewUploadLog,
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    data() {
        return { drawer_visible: false, upload_log: {} };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        onTableAction(data) {
            switch (data.key) {
                case 'open':
                    this.$http.get('/api/import-audit-logs/' + data.id).then((response) => {
                        this.upload_log = {
                            ...response.data.data,
                            created_at: this.$dayjs(response.data.data.created_at).format('YYYY-MM-DD HH:mm:ss'),
                        };
                    });

                    this.drawer_visible = true;
                    break;
            }
        },
        onClose() {
            this.drawer_visible = false;
        },
        reload() {
            this.$refs.UploadLogTable.reload();
        },
    },
};
</script>
